export default __webpack_public_path__ + "static/media/logoHeader2.72ed5e65.png";